




























import Vue from "vue";
import InputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        InputNumber: InputNumber,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "property.outdoor.garden.surface",
            inputName: "garden-surface",
            specificId: uuidv4() as string
        };
    },
    computed: {
        gardenSurface: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        isDisplayed: function(): boolean {
            return this.$store.getters["FormModule/getValue"]("property.outdoor.garden.exists") === true;
        }
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(gardenSurface: number): void {
            if (gardenSurface === 0 && this.gardenSurface != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": gardenSurface});
            }
        }
    }
});

